// src/components/reports/MeslekiDegerlerReports.js

import React from 'react';
import { 
  Brain, BookOpen, BrainCircuit, PieChart as PieChartIcon, TrendingDown,
  Activity, Zap, Compass, Users, Heart, User, Briefcase, Target, Globe, 
  List, Star, Download, Loader2, BarChart3, Sparkles, Wallet, Award, Lightbulb, Shield, TrendingUp, Clock, Megaphone
} from 'lucide-react';
import { 
  ResponsiveContainer, RadarChart, PolarGrid, 
  PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip 
} from 'recharts';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const MeslekiDegerlerReportUI = ({ data, meta }) => {
  const chartData = data.chartData || [];
  const top1 = data.topValues?.[0] || { subject: "Belirsiz", A: 0 };
  const top2 = data.topValues?.[1] || { subject: "Belirsiz", A: 0 };

  // 15 Değerlik Büyük Sözlük
  const DICT = {
    "Kazanç": {
      icon: Wallet, color: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200",
      desc: "Yüksek maaş ve maddi getiri odaklı bir kariyer.",
      traits: "Ekonomik refahı ve finansal özgürlüğü her şeyin önünde tutar. Gelecekteki yaşam standartlarını garanti altına alacak yüksek gelirli pozisyonları hedefler.",
      careers: "Yatırımcı, Ticaret Uzmanı, Finans Direktörü, Girişimci"
    },
    "Prestij": {
      icon: Award, color: "text-purple-700", bg: "bg-purple-50", border: "border-purple-200",
      desc: "Toplumda saygınlık ve itibar kazanma odaklı.",
      traits: "Toplum tarafından saygı duyulan, statüsü yüksek bir unvana sahip olmak ister. Karar verici mekanizmalarda bulunmak ona gurur verir.",
      careers: "Cerrah, Diplomat, Üst Düzey Yönetici, Hukukçu"
    },
    "Bağımsızlık": {
      icon: Compass, color: "text-cyan-700", bg: "bg-cyan-50", border: "border-cyan-200",
      desc: "Kimseden emir almadan özgürce çalışma odaklı.",
      traits: "Kendi kurallarını koymak ve kendi planını çizmek ister. Mikroyönetimden (sürekli denetlenmekten) hoşlanmaz, otonomi arar.",
      careers: "Girişimci, Freelancer, Bağımsız Danışman, Sanatçı"
    },
    "Yaratıcılık": {
      icon: Lightbulb, color: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200",
      desc: "Sürekli yeni ve orijinal ürünler ortaya koyma odaklı.",
      traits: "Rutin ve tekrarlayan işleri sevmez. Yenilikçi, vizyoner ve hayal gücünü kullanabileceği boşluklar arar.",
      careers: "Tasarımcı, Yazar, Yazılım Mimarı, Ar-Ge Uzmanı"
    },
    "Sosyal Yardım": {
      icon: Heart, color: "text-rose-700", bg: "bg-rose-50", border: "border-rose-200",
      desc: "İnsanlara destek olma ve topluma fayda sağlama odaklı.",
      traits: "Yüksek empatiye sahiptir. Başkalarının hayatına doğrudan dokunmaktan ve onlara yardım etmekten derin bir manevi tatmin duyar.",
      careers: "Psikolog, Sosyal Hizmetler Uzmanı, Doktor, Öğretmen"
    },
    "Güvenlik": {
      icon: Shield, color: "text-slate-700", bg: "bg-slate-50", border: "border-slate-200",
      desc: "Riskten uzak, düzenli ve garantili bir iş odaklı.",
      traits: "Belirsizliği sevmez. Yarınının ne olacağını bildiği, iflas veya işten çıkarılma riskinin minimum olduğu kalıcı yapılar arar.",
      careers: "Memuriyet, Bankacı, Kalite Kontrol Uzmanı, İdari Personel"
    },
    "Liderlik": {
      icon: Target, color: "text-red-700", bg: "bg-red-50", border: "border-red-200",
      desc: "Ekipleri yönetme ve yönlendirme odaklı.",
      traits: "İnisiyatif ve sorumluluk almayı sever. İnsanları belli bir amaç uğruna motive edip organize etmekte ustadır.",
      careers: "CEO, Proje Yöneticisi, Siyasetçi, Okul Müdürü"
    },
    "Gelişim": {
      icon: TrendingUp, color: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200",
      desc: "Kişisel potansiyelini sürekli geliştirme odaklı.",
      traits: "Öğrenmeye açtır. Kariyerinde durağanlığı sevmez, sürekli yeni eğitimler alıp yukarı doğru ivmelenmek ister.",
      careers: "Akademisyen, Kurumsal Eğitmen, Veri Analisti"
    },
    "Çeşitlilik": {
      icon: Zap, color: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200",
      desc: "Rutin olmayan, hareketli ve değişken işler odaklı.",
      traits: "Masa başında sabit kalmaktan sıkılır. Macera, seyahat ve her gün farklı bir olayla karşılaşacağı dinamizm arar.",
      careers: "Tur Rehberi, Gazeteci, Etkinlik Yöneticisi, Saha Mühendisi"
    },
    "Esneklik": {
      icon: Clock, color: "text-teal-700", bg: "bg-teal-50", border: "border-teal-200",
      desc: "İş ve özel hayat dengesini kurma odaklı.",
      traits: "Zamanını kendi yönetmek ister. Çalışma saatlerinin esnek olmasını, ailesine ve hobilerine bolca vakit kalmasını bekler.",
      careers: "Dijital Göçebe, E-Ticaret Uzmanı, Bağımsız Danışman"
    },
    "Estetik": {
      icon: Sparkles, color: "text-pink-700", bg: "bg-pink-50", border: "border-pink-200",
      desc: "Güzellik ve tasarım üretme odaklı.",
      traits: "Görsel zevklere önem verir. Çevresini, nesneleri veya mekanları göze hitap edecek şekilde güzelleştirmeyi hedefler.",
      careers: "Mimar, İç Mimar, Moda Tasarımcısı, Grafik Tasarımcı"
    },
    "Tanınma": {
      icon: Megaphone, color: "text-fuchsia-700", bg: "bg-fuchsia-50", border: "border-fuchsia-200",
      desc: "Geniş kitlelerce bilinme ve takdir edilme odaklı.",
      traits: "Yaptığı işlerle ön planda olmayı, isminin duyulmasını ve halk tarafından alkışlanmayı motive edici bulur.",
      careers: "Sanatçı, Medya/İletişim Uzmanı, İçerik Üreticisi, Yazar"
    },
    "Zihinsel Uyarım": {
      icon: BrainCircuit, color: "text-indigo-700", bg: "bg-indigo-50", border: "border-indigo-200",
      desc: "Karmaşık problemleri çözme ve zihni zorlama odaklı.",
      traits: "Analitik düşünmeyi sever. Basit ve sıradan işler ona yetersiz gelir, beynini tam kapasite kullanacağı zorluklar arar.",
      careers: "Araştırmacı, Veri Bilimci, Stratejist, Yazılım Mühendisi"
    },
    "İdealizm": {
      icon: Globe, color: "text-lime-700", bg: "bg-lime-50", border: "border-lime-200",
      desc: "Dünyayı daha iyi bir yer haline getirme odaklı.",
      traits: "Kendi değerlerine sıkı sıkıya bağlıdır. Yaptığı işin ekolojik, politik veya toplumsal büyük bir amaca hizmet etmesini ister.",
      careers: "Çevrebilimci, Sivil Toplum Önderi, Sosyal Girişimci"
    },
    "Sosyal İlişkiler": {
      icon: Users, color: "text-sky-700", bg: "bg-sky-50", border: "border-sky-200",
      desc: "Sıcak bir takım ortamında ve uyum içinde çalışma odaklı.",
      traits: "İş yerindeki arkadaşlıklara önem verir. Toksik rekabetten uzak, herkesin birbirini desteklediği sıcak bir ortam arar.",
      careers: "İnsan Kaynakları Uzmanı, Takım Lideri, Kurumsal İletişim"
    }
  };

  // Güvenlik Koruması (Fallback)
  
  const p1 = DICT[top1.subject] || DICT["Güvenlik"];
  const p2 = DICT[top2.subject] || DICT["Gelişim"];

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      {/* ÜST BAŞLIK */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner bg-indigo-600 print:bg-slate-800">
            <Target className="h-6 w-6 print:h-4 print:w-4 text-white"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Mesleki Değerler ve Motivasyon</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl print:text-xl font-black block leading-none text-indigo-300 print:text-indigo-700">%{top1.A}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">En Yüksek Uyum</span>
        </div>
      </div>

      {/* RADAR GRAFİK VE BASKIN TİPLER */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4 shrink-0 avoid-break">
        
        {/* RADAR CHART */}
        <div className="bg-white p-2 rounded-2xl border border-slate-200 shadow-sm flex flex-col items-center justify-center h-[300px] print:h-[250px] print:border-slate-300">
          <h3 className="font-bold text-slate-800 text-xs uppercase tracking-widest mt-2">Kariyer Pusulası Dağılımı</h3>
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart cx="50%" cy="50%" outerRadius="65%" data={chartData}>
              <PolarGrid stroke="#e2e8f0" />
              <PolarAngleAxis dataKey="subject" tick={{ fill: '#64748b', fontSize: 8, fontWeight: 'bold' }} />
              <PolarRadiusAxis angle={30} domain={[0, 100]} tick={false} axisLine={false} />
              <Radar name="Motivasyon" dataKey="A" stroke="#4f46e5" strokeWidth={2} fill="#6366f1" fillOpacity={0.5} />
              <Tooltip formatter={(value) => [`%${value}`, 'Uyum']} />
            </RadarChart>
          </ResponsiveContainer>
        </div>

        {/* BASKIN 2 DEĞER KARTI */}
        <div className="flex flex-col gap-4 print:gap-3">
          <div className={`${p1.bg} p-5 print:p-4 rounded-2xl border ${p1.border} shadow-sm flex-1 flex flex-col justify-center print:bg-white print:border-slate-300`}>
            <div className="flex items-center mb-2 border-b pb-2 opacity-80 print:border-slate-200">
              <p1.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${p1.color}`}/>
              <span className={`text-xs font-black uppercase tracking-widest ${p1.color}`}>1. Temel Kariyer Değeri</span>
            </div>
            <h3 className={`text-xl print:text-lg font-black leading-tight mb-2 ${p1.color}`}>{top1.subject}</h3>
            <p className="text-[11px] print:text-[9.5px] text-slate-700 font-medium leading-snug"><strong>Motivasyon:</strong> {p1.desc}</p>
          </div>

          <div className={`${p2.bg} p-5 print:p-4 rounded-2xl border ${p2.border} shadow-sm flex-1 flex flex-col justify-center print:bg-white print:border-slate-300`}>
            <div className="flex items-center mb-2 border-b pb-2 opacity-80 print:border-slate-200">
              <p2.icon className={`h-5 w-5 print:h-4 print:w-4 mr-2 ${p2.color}`}/>
              <span className={`text-xs font-black uppercase tracking-widest ${p2.color}`}>2. Destekleyici Değer</span>
            </div>
            <h3 className={`text-xl print:text-lg font-black leading-tight mb-2 ${p2.color}`}>{top2.subject}</h3>
            <p className="text-[11px] print:text-[9.5px] text-slate-700 font-medium leading-snug"><strong>Motivasyon:</strong> {p2.desc}</p>
          </div>
        </div>
      </div>

      {/* KARİYER VE ÖZELLİK VİTRİNİ */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-4 print:gap-4 shrink-0 avoid-break">
        <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm print:bg-white print:border-slate-300 flex flex-col">
           <h4 className="font-bold text-slate-800 text-xs uppercase tracking-widest border-b pb-2 mb-3 flex items-center"><User className="h-4 w-4 mr-2 text-slate-500"/> İdeal Çalışma Koşulları</h4>
           <p className="text-xs print:text-[10.5px] text-slate-700 font-medium leading-relaxed text-justify mb-3">
             <span className="font-bold text-indigo-700">{top1.subject}:</span> {p1.traits}
           </p>
           <p className="text-xs print:text-[10.5px] text-slate-700 font-medium leading-relaxed text-justify">
             <span className="font-bold text-indigo-700">{top2.subject}:</span> {p2.traits}
           </p>
        </div>
        <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm print:bg-white print:border-slate-300 flex flex-col">
           <h4 className="font-bold text-slate-800 text-xs uppercase tracking-widest border-b pb-2 mb-3 flex items-center"><Briefcase className="h-4 w-4 mr-2 text-slate-500"/> Uygun Kariyer Alanları</h4>
           <p className="text-xs print:text-[10.5px] text-slate-700 font-medium leading-relaxed text-justify mb-3">
             <span className="font-bold text-indigo-700">{top1.subject}:</span> {p1.careers}
           </p>
           <p className="text-xs print:text-[10.5px] text-slate-700 font-medium leading-relaxed text-justify">
             <span className="font-bold text-indigo-700">{top2.subject}:</span> {p2.careers}
           </p>
        </div>
      </div>

    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateMeslekiDegerler = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  const typeScores = {
      "Kazanç": 0, "Prestij": 0, "Bağımsızlık": 0, "Yaratıcılık": 0, "Sosyal Yardım": 0,
      "Güvenlik": 0, "Liderlik": 0, "Gelişim": 0, "Çeşitlilik": 0, "Esneklik": 0,
      "Estetik": 0, "Tanınma": 0, "Zihinsel Uyarım": 0, "İdealizm": 0, "Sosyal İlişkiler": 0
  };

  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, typeScores: { ...typeScores } };
    }
    classMap[className].studentCount++;

    const chartData = s.reportData?.chartData || [];
    
    if (chartData.length > 0) {
        chartData.forEach(item => {
            if (typeScores[item.subject] !== undefined) {
                typeScores[item.subject] += item.A; // item.A yüzdelik skordur (0-100)
                classMap[className].typeScores[item.subject] += item.A;
            }
        });
    }
  });

  // Toplam skorları ortalamaya çeviriyoruz
  const avgScores = Object.entries(typeScores).map(([subject, totalScore]) => ({
      subject,
      avgScore: total > 0 ? Math.round(totalScore / total) : 0,
      percent: total > 0 ? Math.round(totalScore / total) : 0 // Zaten yüzde geldiği için aynısı
  })).sort((a, b) => b.avgScore - a.avgScore);

  const topDominant = avgScores[0];
  const secondDominant = avgScores[1];
  const thirdDominant = avgScores[2];

  const classStats = Object.values(classMap).map(c => {
      let topType = "Belirsiz";
      let maxScore = -1;
      
      if (c.typeScores && c.studentCount > 0) {
          Object.entries(c.typeScores).forEach(([type, totalScore]) => {
              const avg = Math.round(totalScore / c.studentCount);
              if (avg > maxScore) { 
                  maxScore = avg; 
                  topType = type; 
              }
          });
      }
      return { ...c, topType, percentInClass: maxScore };
  }).sort((a, b) => b.studentCount - a.studentCount); 

  return { total, avgScores, topDominant, secondDominant, thirdDominant, classStats };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const MeslekiDegerlerKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateMeslekiDegerler(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const typeStyles = {
      "Kazanç": { color: "text-emerald-700", bg: "bg-emerald-50", bar: "bg-emerald-500", icon: Wallet },
      "Prestij": { color: "text-purple-700", bg: "bg-purple-50", bar: "bg-purple-500", icon: Award },
      "Bağımsızlık": { color: "text-cyan-700", bg: "bg-cyan-50", bar: "bg-cyan-500", icon: Compass },
      "Yaratıcılık": { color: "text-amber-700", bg: "bg-amber-50", bar: "bg-amber-500", icon: Lightbulb },
      "Sosyal Yardım": { color: "text-rose-700", bg: "bg-rose-50", bar: "bg-rose-500", icon: Heart },
      "Güvenlik": { color: "text-slate-700", bg: "bg-slate-50", bar: "bg-slate-500", icon: Shield },
      "Liderlik": { color: "text-red-700", bg: "bg-red-50", bar: "bg-red-500", icon: Target },
      "Gelişim": { color: "text-blue-700", bg: "bg-blue-50", bar: "bg-blue-500", icon: TrendingUp },
      "Çeşitlilik": { color: "text-orange-700", bg: "bg-orange-50", bar: "bg-orange-500", icon: Zap },
      "Esneklik": { color: "text-teal-700", bg: "bg-teal-50", bar: "bg-teal-500", icon: Clock },
      "Estetik": { color: "text-pink-700", bg: "bg-pink-50", bar: "bg-pink-500", icon: Sparkles },
      "Tanınma": { color: "text-fuchsia-700", bg: "bg-fuchsia-50", bar: "bg-fuchsia-500", icon: Megaphone },
      "Zihinsel Uyarım": { color: "text-indigo-700", bg: "bg-indigo-50", bar: "bg-indigo-500", icon: BrainCircuit },
      "İdealizm": { color: "text-lime-700", bg: "bg-lime-50", bar: "bg-lime-500", icon: Compass }, // Fallback
      "Sosyal İlişkiler": { color: "text-sky-700", bg: "bg-sky-50", bar: "bg-sky-500", icon: Users }
  };

  const TopIcon = typeStyles[data.topDominant.subject]?.icon || Star;
  const topColor = typeStyles[data.topDominant.subject]?.color || "text-slate-800";

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('degerler-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="degerler-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          <div className="bg-slate-900 text-white p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm shrink-0 avoid-break print:bg-white print:text-black print:border-b-2 print:border-slate-900">
            <div className="flex items-center gap-5 print:gap-3">
              <div className="h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner bg-indigo-600 print:bg-slate-800">
                <Target className="h-7 w-7 print:h-5 print:w-5 text-white"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">KARİYER BEKLENTİLERİ VE DEĞERLER ANALİZİ</span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 rounded-xl text-center print:border print:border-slate-300">
              <span className="text-3xl print:text-xl font-black block text-indigo-300 print:text-indigo-700">{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.topDominant.subject]?.bg} print:bg-white print:border-slate-300`}>
              <div className="flex items-center mb-1.5">
                 <TopIcon className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${topColor}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${topColor}`}>1. Baskın Beklenti</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${topColor}`}>{data.topDominant.subject} <span className="text-xs font-medium opacity-70">(%{data.topDominant.percent})</span></p>
            </div>
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.secondDominant.subject]?.bg || 'bg-slate-50'} print:bg-white print:border-slate-300`}>
              <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${typeStyles[data.secondDominant.subject]?.color || 'text-slate-700'}`}>2. İkinci Motivasyon</span>
              <p className={`text-2xl print:text-lg font-black mt-1 ${typeStyles[data.secondDominant.subject]?.color || 'text-slate-800'}`}>{data.secondDominant.subject} <span className="text-xs font-medium opacity-70">(%{data.secondDominant.percent})</span></p>
            </div>
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center ${typeStyles[data.thirdDominant.subject]?.bg || 'bg-slate-50'} print:bg-white print:border-slate-300`}>
              <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${typeStyles[data.thirdDominant.subject]?.color || 'text-slate-700'}`}>3. Destekleyici Değer</span>
              <p className={`text-2xl print:text-lg font-black mt-1 ${typeStyles[data.thirdDominant.subject]?.color || 'text-slate-800'}`}>{data.thirdDominant.subject} <span className="text-xs font-medium opacity-70">(%{data.thirdDominant.percent})</span></p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 flex flex-col justify-center shadow-sm print:bg-white print:border-slate-300">
               <h3 className="font-bold text-blue-900 mb-3 flex items-center text-xs uppercase tracking-widest border-b border-blue-200 pb-1.5"><Users className="h-5 w-5 mr-2 text-blue-600"/> Sınıfların Temel Motivasyonları</h3>
               <div className="space-y-2 mt-1">
                 <div>
                    <span className="text-[10px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">Öne Çıkan Grup: {data.classStats[0] ? data.classStats[0].name : '-'}</span>
                    <p className="text-sm font-black text-slate-800 leading-tight">Değer: {data.classStats[0] ? data.classStats[0].topType : 'Belirsiz'} <span className="text-[10px] font-bold text-indigo-600">(%{data.classStats[0]?.percentInClass})</span></p>
                 </div>
                 <div>
                    <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">İkinci Grup: {data.classStats[1] ? data.classStats[1].name : '-'}</span>
                    <p className="text-xs font-black text-slate-700 leading-tight">Değer: {data.classStats[1] ? data.classStats[1].topType : 'Belirsiz'} <span className="text-[10px] font-bold text-indigo-500">(%{data.classStats[1]?.percentInClass})</span></p>
                 </div>
               </div>
            </div>

            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 flex flex-col justify-center shadow-sm print:bg-white print:border-slate-300">
               <h3 className="font-bold text-purple-900 mb-3 flex items-center text-xs uppercase tracking-widest border-b border-purple-200 pb-1.5"><Briefcase className="h-5 w-5 mr-2 text-purple-600"/> Kurumsal Kariyer Yönelimi</h3>
               <p className="text-[11px] text-slate-700 leading-snug font-medium mt-1 text-justify">
                 Bu kurumdaki öğrencilerin kariyer motivasyonları ağırlıklı olarak <strong>{data.topDominant.subject}</strong> ve <strong>{data.secondDominant.subject}</strong> değerleri etrafında şekillenmektedir. Okulun kariyer günleri ve staj yönlendirmeleri bu beklentileri karşılayacak sektörlere göre tasarlanmalıdır.
               </p>
            </div>

            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 shadow-sm print:bg-white print:border-slate-300">
               <div className="flex justify-between items-center border-b border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs uppercase tracking-widest"><BarChart3 className="h-5 w-5 mr-2 text-slate-600"/> Değer Boyutları Genel Uyum Yüzdeleri</h3>
                 <span className="text-[10px] text-slate-500 italic">Max: %100</span>
               </div>
               <div className="space-y-3 print:space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                  {data.avgScores.map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.subject}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent}</span>
                      </div>
                      <div className="h-2 w-full bg-slate-200 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className={`h-full rounded-full ${typeStyles[dim.subject]?.bar || 'bg-slate-500'} print:bg-slate-600`} style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>
          </div>

          {/* VİZYONER STRATEJİ KARTI */}
          {(() => {
              const lowestValue = data.avgScores[data.avgScores.length - 1];
              return (
                  <div className="grid grid-cols-2 gap-4 mt-2 print:mt-1 avoid-break">
                      <div className="bg-orange-50/50 rounded-2xl p-3 border border-orange-100 flex items-start print:bg-white print:border-slate-200">
                          <div className="bg-orange-100 p-2 rounded-lg mr-3 print:hidden shrink-0 mt-0.5">
                              <TrendingDown className="h-5 w-5 text-orange-600" />
                          </div>
                          <div className="flex-1">
                              <div className="flex justify-between items-start mb-0.5">
                                  <p className="text-[10px] font-bold text-orange-800/70 uppercase tracking-widest">GÖZ ARDI EDİLEN DEĞER</p>
                                  <span className="text-[9px] font-bold text-orange-600 bg-orange-100 px-1.5 py-0.5 rounded print:hidden">% {lowestValue?.percent}</span>
                              </div>
                              <h4 className="font-black text-slate-800 text-sm mb-1.5">{lowestValue?.subject}</h4>
                              <div className="pt-1.5 border-t border-orange-200/60">
                                  <p className="text-[9.5px] text-orange-900/80 leading-snug font-medium text-justify">
                                      <strong className="text-orange-700">Analiz:</strong> Bu değerin düşük çıkması, öğrencilerin kariyer planlarında bu alanı ikincil planda tuttuğunu gösterir. Rehberlik servisi bu alanın (örn. İdealizm veya Sosyal Yardım) eksikliğini farkındalık seminerleriyle dengeleyebilir.
                                  </p>
                              </div>
                          </div>
                      </div>

                      <div className="bg-emerald-50/50 rounded-2xl p-3 border border-emerald-100 flex items-start print:bg-white print:border-slate-200">
                          <div className="bg-emerald-100 p-2 rounded-lg mr-3 print:hidden shrink-0 mt-0.5">
                              <Target className="h-5 w-5 text-emerald-600" />
                          </div>
                          <div className="flex-1">
                              <p className="text-[10px] font-bold text-emerald-800/70 uppercase tracking-widest mb-0.5">ÖNCELİKLİ KARİYER ETKİNLİĞİ</p>
                              <h4 className="font-black text-slate-800 text-sm mb-1.5">Baskın Motive Ediciler</h4>
                              <div className="pt-1.5 border-t border-emerald-200/60">
                                  <p className="text-[9.5px] text-emerald-900/80 leading-snug font-medium text-justify">
                                      <strong className="text-emerald-700">Aksiyon:</strong> Kurumun düzenleyeceği kariyer günlerine, "<strong>{data.topDominant.subject}</strong>" ve "<strong>{data.secondDominant.subject}</strong>" değerlerine uygun rol modeller (örneğin girişimciler veya üst düzey yöneticiler) davet edilmelidir.
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              );
          })()}

        </div>

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* AI RAPORU BÖLÜMÜ */}
        <div className="flex flex-col mt-4 print:mt-0">
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl border border-purple-100 shadow-sm flex flex-col pt-2 print:bg-white print:border-none print:shadow-none">
            <div className="flex justify-between items-center mb-4 border-b border-purple-200 pb-3 shrink-0 print:border-slate-300">
              <h3 className="font-bold text-purple-900 flex items-center text-base uppercase tracking-widest print:hidden"><Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Strateji Raporu</h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full"><Brain className="h-5 w-5 mr-2"/> Kurumsal Kariyer Beklentileri Analizi</h3>
              <button onClick={() => onGenerateAI(title, data.avgScores)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>} {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};